import { DeliveryNote } from '@features/deliveryNotes/types/deliveryNote'

import apiZervant from '../../utils/apiZervant'

// Zervant only exposes delivery notes via GraphQL. Migrate this to a REST
// endpoint once a proper Delivery Notes backend exists.
const DELIVERY_NOTES_QUERY = `
  {
    deliverynotes {
      id
      deliverynoteNumber
      issueDate
      customer {
        companyName
        firstName
        lastName
      }
    }
  }
`

interface DeliveryNoteCustomerResponse {
  companyName: string | null
  firstName: string | null
  lastName: string | null
}

interface DeliveryNoteResponse {
  customer: DeliveryNoteCustomerResponse
  deliverynoteNumber: string
  id: number
  issueDate: string
}

interface DeliveryNotesGraphqlResponse {
  data: {
    deliverynotes: DeliveryNoteResponse[]
  }
}

const getCustomerDisplayName = (customer: DeliveryNoteCustomerResponse): string =>
  customer.companyName || [customer.firstName, customer.lastName].filter(Boolean).join(' ')

const normalizeDeliveryNoteResponse = (deliveryNote: DeliveryNoteResponse): DeliveryNote => ({
  contactName: getCustomerDisplayName(deliveryNote.customer),
  date: deliveryNote.issueDate,
  id: String(deliveryNote.id),
  number: deliveryNote.deliverynoteNumber,
})

export const fetchDeliveryNotes = async (): Promise<DeliveryNote[]> => {
  const response = await apiZervant.restInvoiceGraphql.post<DeliveryNotesGraphqlResponse>('', {
    query: DELIVERY_NOTES_QUERY,
    variables: {},
  })

  return response.data.data.deliverynotes.map(normalizeDeliveryNoteResponse)
}
